var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingStoreBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 0H4C1.79086 0 0 1.79086 0 4V67C0 69.2091 1.79086 71 4 71H67C69.2091 71 71 69.2091 71 67V4C71 1.79086 69.2091 0 67 0Z",
    fill: "#1E3557",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5467 49H21.789C18.5923 49 16 46.41 16 43.2133V26.7867C16 23.5923 18.5923 21 21.789 21H47.5467C50.7433 21 53.3333 23.5923 53.3333 26.7867V43.2133C53.3333 46.41 50.7433 49 47.5467 49Z",
    fill: "#1E3557"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0465 40.76C25.2691 40.76 25.4287 40.6592 25.4959 40.4282L26.0621 38.6516H30.5747L31.1409 40.4282C31.2081 40.6592 31.3677 40.76 31.5903 40.76H33.2745C33.5643 40.76 33.7029 40.5962 33.6063 40.3106H33.6061L29.8681 29.3318C29.8009 29.1134 29.6287 29 29.4061 29H27.2305C27.0079 29 26.8357 29.1134 26.7685 29.3318L23.0305 40.3106C22.9339 40.5962 23.0725 40.76 23.3623 40.76H25.0465ZM29.8843 36.4844H26.7527L28.3185 31.5704L29.8843 36.4844ZM39.8977 40.76C43.1401 40.76 45.5677 38.1854 45.5677 34.88C45.5677 31.5746 43.1401 29 39.8977 29H35.2987C35.0425 29 34.8997 29.1428 34.8997 29.399V40.361C34.8997 40.6172 35.0425 40.76 35.2987 40.76H39.8977ZM39.8977 38.5424H37.2097V31.2176H39.8977C41.9389 31.2176 43.3417 32.7086 43.3417 34.88C43.3417 37.0514 41.9389 38.5424 39.8977 38.5424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingStoreBanner);
export default __webpack_public_path__ + "static/media/marketing-store-banner.cca82ae53cdee3909802e62aa0332daf.svg";
export { ForwardRef as ReactComponent };